export default __webpack_public_path__ + "static/bunker_staff_upgrade-001846bdadb7e78ef6b04e5f40de39d9.png";